const activityChart = {
    series: [{
        name: 'Active Hours',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: false,
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '14%',
                endingShape: 'rounded'
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        },
        yaxis: {
            title: {
                text: 'Active Hours'
            }
        },
        fill: {
            opacity: 1

        },
        colors: ['#556ee6'],
    }
};

const mostUsedAppChart = {
    series: [0, 0, 0, 0, 0],
    chartOptions: {
        labels: ["N.A", "N.A", "N.A", "N.A", "N.A"],
        colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'left',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 240
                },
                legend: {
                    show: false
                },
            }
        }]
    }
};

export { activityChart, mostUsedAppChart };